import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Collapsible from 'react-collapsible';
import '../Styles/Sidebar.css';
import PercentageBar from './PercentageBar';


const ReligionPageSide = (props) => {
        return (
            <>

                    <div className='religionIntro'>
                        {props.religion=="Buddhism"&&(
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, 
                                sed diam nonummy nibh Lorem ipsum dolor sit amet, consectetuer adipiscing elit, 
                                sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. 
                                Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis 
                                nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit 
                                in Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh 
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod 
                                tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, 
                                quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo 
                                consequat. Duis autem vel eum iriure dolor in hendrerit in</p>
                        )}
                    </div>
                    <div className='religionProfile'>
                        Provincial Profile
                            <div className="religionPageInfoDisplay">
                                <div><b>{props.country} {props.province}</b></div>
                                <div><b>Dominant Religion:</b><br /> {props.firstReligion}</div>
                                <PercentageBar percent1={props.numerical} religion1={props.firstReligion}/>
                                <div><b>Sub-dominant Religion:</b><br /> {props.secondReligion||"none"}</div>
                                {props.secondReligion&&(
                                    <>
                                    <PercentageBar percent1={props.numeric_1} religion1={props.secondReligion}/>
                                    <br />
                                    </>
                                    )
                                }
                                <div style={{lineHeight:"12px",fontSize:"8px"}}>Data Source: <br/>
                                <a href={props.dataURL}>{props.dataSource}</a></div>
                            </div>
                    </div>
                    
            
                

                
            </>
                
        )
}

export default ReligionPageSide;